export default __webpack_public_path__ + "static/media/homeLogoCthulhuEpics_210.49450461.png";